import {HttpClient} from '@angular/common/http';
import {Inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {PayrollInvitation, PayrollInviteRequest, PayrollRedeemResult} from './payroll.models';

/**
 * Talks to the monolith's payroll endpoints: company-owner invitation management
 * (`/payroll/invitation`) and the accountant's redeem (`/auth/payroll/redeem`). Single BASE_URL origin; the
 * AuthInterceptor attaches the context token.
 */
@Injectable({providedIn: 'root'})
export class PayrollHttpService {
  constructor(private http: HttpClient, @Inject('BASE_URL') private baseUrl: string) {
  }

  /** Company owner: invite an accountant by email. The response carries the one-time code once. */
  invite(request: PayrollInviteRequest): Observable<PayrollInvitation> {
    return this.http.post<PayrollInvitation>(`${this.baseUrl}/payroll/invitation`, request);
  }

  /** Company owner: list the company's invitations/grants. */
  list(): Observable<PayrollInvitation[]> {
    return this.http.get<PayrollInvitation[]>(`${this.baseUrl}/payroll/invitation`);
  }

  /** Company owner: revoke an invitation/grant. */
  revoke(id: string): Observable<PayrollInvitation> {
    return this.http.post<PayrollInvitation>(`${this.baseUrl}/payroll/invitation/${id}/revoke`, {});
  }

  /** Accountant (external session): redeem an invitation code, unlocking the inviting company. */
  redeem(code: string): Observable<PayrollRedeemResult> {
    return this.http.post<PayrollRedeemResult>(`${this.baseUrl}/auth/payroll/redeem`, {code});
  }
}
